(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["casedq-photo-shirt"] && !Shopify.designMode) return;
  try {
    
function setupCqShirt(root){
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const variants=JSON.parse(root.querySelector('[data-cq-variants]').textContent);
  const labels=JSON.parse(root.querySelector('[data-cq-labels]').textContent);
  const form=root.querySelector('form');
  const fileInput=root.querySelector('[data-photo-input]');
  const error=root.querySelector('[data-error]');
  const add=root.querySelector('[data-add]');
  const photo=root.querySelector('[data-photo-image]');
  let photoUrl=null;
  let photoReady=false;
  const updateVariant=()=>{
    const options=[...root.querySelectorAll('[data-option-position]')].map(group=>group.querySelector('input:checked')?.value);
    const variant=variants.find(item=>item.options.every((value,index)=>value===options[index]));
    root.querySelector('[data-variant-id]').value=variant?.id||'';
    root.querySelector('[data-price]').textContent=variant?.price||'';
    add.disabled=!variant?.available;
    root.querySelector('[data-add-label]').textContent=variant?.available?labels.add:labels.soldOut;
    const color=options.find(value=>['White','Black','Natural'].includes(value));
    root.querySelector('[data-shirt-fill]').setAttribute('fill',{'White':'#ffffff','Black':'#303033','Natural':'#e9deca'}[color]||'#ffffff');
  };
  root.querySelectorAll('[data-option-position] input').forEach(input=>input.addEventListener('change',updateVariant));
  root.querySelector('[data-text-input]').addEventListener('input',event=>{
    root.querySelector('textPath').textContent=event.target.value.toUpperCase();
    root.querySelector('[data-preview-text]').setAttribute('font-size',Math.min(31,350/Math.max(event.target.value.length,1)));
  });
  root.querySelector('[data-ink]').addEventListener('input',event=>root.querySelector('[data-preview-text]').setAttribute('fill',event.target.value));
  root.querySelector('[data-curve]').addEventListener('input',event=>root.querySelector('[data-text-path]').setAttribute('d',`M 186 237 Q 300 ${237-Number(event.target.value)} 414 237`));
  fileInput.addEventListener('change',()=>{
    error.hidden=true;photoReady=false;fileInput.setCustomValidity('');
    photo.removeAttribute('href');root.querySelector('[data-photo-empty]').removeAttribute('display');
    if(photoUrl){URL.revokeObjectURL(photoUrl);photoUrl=null;}
    const file=fileInput.files[0];if(!file)return;
    if(!['image/jpeg','image/png','image/webp'].includes(file.type)||file.size>10*1024*1024){fileInput.value='';error.textContent=labels.fileError;error.hidden=false;return;}
    const url=URL.createObjectURL(file);photoUrl=url;const probe=new Image();
    probe.onload=()=>{if(photoUrl!==url)return;photo.setAttribute('href',url);root.querySelector('[data-photo-empty]').setAttribute('display','none');photoReady=true;};
    probe.onerror=()=>{if(photoUrl!==url)return;fileInput.value='';error.textContent=labels.imageError;error.hidden=false;};
    probe.src=url;
  });
  form.addEventListener('submit',event=>{if(!photoReady){event.preventDefault();error.textContent=labels.imageError;error.hidden=false;fileInput.focus();}});
  updateVariant();
}
document.querySelectorAll('.cq-shirt').forEach(setupCqShirt);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.cq-shirt').forEach(setupCqShirt));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
